import React from "react";
import { IconButton, Tooltip } from "@mui/material";

interface CustomIconButtonProps {
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  iconButtonSx?: Record<string, unknown>;
  tooltip?: string;
}

export const CustomIconButton: React.FC<CustomIconButtonProps> = ({
  icon,
  onClick,
  disabled = false,
  iconButtonSx,
  tooltip,
}) => {
  const button = (
    <IconButton
      onClick={() => {
        onClick();
      }}
      disabled={disabled}
      sx={{
        color: "#0E4664",
        p: 0.5,
        lineHeight: 0,
        "&:hover": {
          backgroundColor: "#e1efea",
        },
        "& img": {
          width: 22,
          height: 22,
          display: "block",
        },
        "& .MuiSvgIcon-root": {
          fontSize: 22,
        },
        ...(iconButtonSx ?? {}),
      }}
      disableRipple={true}
    >
      {icon}
    </IconButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip title={tooltip} arrow>
      <span>{button}</span>
    </Tooltip>
  );
};
